import type { LiquidGlassSettings } from '@/hooks';

/**
 * Shared liquid-glass material settings — the same material the auth
 * forms use (originally tuned in the liquid-glass prototype against that
 * card), reused for MainLayout's header pill so both read as one
 * consistent glass material. See useLiquidGlass, AuthLayout.tsx,
 * MainLayout.tsx.
 */
export const FORM_GLASS_SETTINGS: LiquidGlassSettings = {
  radius: 24,
  profile: 'convex',
  bezel: 34,
  thickness: 34,
  ior: 1.57,
  refraction: 2.28,
  blur: 5.5,
  saturate: 100,
  tint: '#ffffff',
  tintOpacity: 0.02,
  highlight: 0,
  highlightFocus: 6,
  lightAngle: 225,
  bipolar: true,
  edge: 0.45,
  edgePeak: 0.58,
  shadow: 0,
};
